import { type CollectionsRoutingConfig } from 'domains/collections/types/collections.types'

export const navCollectionsRetailerRoutingConfig: CollectionsRoutingConfig = {
  list: 'retailer-nav-collections-list',
  // placeholder show/edit routes
  show: 'retailer-nav-collections-show',
  edit: 'retailer-nav-collections-show',
  new: 'retailer-nav-collections-new',
}

export const navCollectionsAdminRoutingConfig: CollectionsRoutingConfig = {
  list: 'app-admin-nav-collections-list',
  // placeholder show/edit routes
  show: 'app-admin-nav-collections-show',
  edit: 'app-admin-nav-collections-show',
  new: 'app-admin-nav-collections-new',
}
